import React, { FC } from 'react';
import { Box, EmptyState, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { templatesPath, useShallowRouter } from '@components/Hooks/useRouter';

type Props = {};

const NotFoundErrorState: FC<Props> = ({}) => {
  const { t } = useTranslation();
  const { router } = useShallowRouter();

  function reloadPage() {
    router.push(templatesPath);
  }

  return (
    <Box
      align="center"
      verticalAlign="middle"
      width="100%"
      height="100%"
      dataHook="template-not-found-error-state"
    >
      <EmptyState
        theme="page-no-border"
        title={t('marketplace.template-not-found-error-title')}
        subtitle={t('marketplace.template-not-found-error-subtitle')}
      >
        <TextButton onClick={reloadPage}>
          {t('marketplace.template-not-found-error-cta')}
        </TextButton>
      </EmptyState>
    </Box>
  );
};

export default NotFoundErrorState;
